import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

type JobBadgeColor =
  | "sun-100"
  | "sun-75"
  | "sun-50"
  | "sun-25"
  | "sand-100"
  | "sand-50"
  | "sand-10"
  | "sky-100"
  | "sky-50"
  | "sky-20"
  | "sky-10"
  | "red-100"
  | "red-50";

type JobBadgeProps = {
  label: string;
  color?: JobBadgeColor;
} & ComponentProps<"span">;

const colorMap: Record<JobBadgeColor, string> = {
  "sun-100": "bg-sun-100",
  "sun-75": "bg-sun-75",
  "sun-50": "bg-sun-50",
  "sun-25": "bg-sun-25",
  "sand-100": "bg-sand-100",
  "sand-50": "bg-sand-50",
  "sand-10": "bg-sand-10",
  "sky-100": "bg-sky-100 text-white",
  "sky-50": "bg-sky-50",
  "sky-20": "bg-sky-20",
  "sky-10": "bg-sky-10",
  "red-100": "bg-red-100 text-white",
  "red-50": "bg-red-50",
};

const JobBadge = ({ label, color = "sand-100", className, ...rest }: JobBadgeProps) => {
  return (
    <span
      className={cn(
        "text-subline-sm inline-flex items-center rounded-full px-2 py-1 text-black-80",
        colorMap[color] || colorMap["sand-100"],
        className,
      )}
      {...rest}
    >
      {label}
    </span>
  );
};

export { JobBadge };
export type { JobBadgeProps, JobBadgeColor };
